const messages_de = {

};

export default messages_de